/**
 * @file _view/_modal.js
 */
(function ($) {
	'use strict';

	/**
	 * @namespace Modal
	 * @constructor
	 * @classdesc Modal
	 * @param {Object} $e -対象となる jQuery オブジェクト
	 */
	var Modal = function ($e) {
		this._$e = $e;
		this._$e.on('click', this.showModal.bind(this));
		$(window).on('resize', this.centeringModal.bind(this));
	};

	/**
	 * @memberof Modal
	 * @const {string}
	 */
	Modal._classname = 'Modal';


	/**
	 * モーダルを立ち上げる
	 *
	 * @memberof Modal
	 * @return {undefined}
	 */
	Modal.prototype.showModal = function () {
		var modal = $('.nk-modal');
		$('body').append('<div class="nk-modal__overlay"></div>');
		var $overlay = $('.nk-modal__overlay');
		this.centeringModal();
		$overlay.fadeIn('fast');
		modal.fadeIn('slow');
		$overlay.on('click', this.hideModal.bind(this));
	};

	/**
	 * モーダルを閉じる
	 *
	 * @memberOf Modal
	 * @return {undefined}
	 */
	Modal.prototype.hideModal = function() {
		if ($('body').hasClass('gc-sp')) {
			$('html').css('-webkit-transform', 'translate3d(0px, 0px, 1px)');
		}
		$('.nk-modal__overlay, .nk-modal').fadeOut('fast', function() {
			$('.nk-modal__overlay').remove();
		});
	};


	/**
	 * モーダルを中央寄せ
	 *
	 * @memberOf Modal
	 * @return {undefined}
	 */
	Modal.prototype.centeringModal = function(modal) {
		var modal = $('.nk-modal');
		var w = $(window).width() ;
		var h = $(window).height() ;
		var cw = modal.outerWidth();
		var ch = modal.outerHeight();
		modal.css({'left': ((w - cw)/2) + 'px','top': ((h - ch)/2) + 'px'});
	};


	module.exports = Modal;
})(jQuery);